"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IccIcureApi = void 0;
/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
const XHR_1 = require("./XHR");
const Contact_1 = require("../model/Contact");
const Document_1 = require("../model/Document");
const Form_1 = require("../model/Form");
const HealthElement_1 = require("../model/HealthElement");
const IndexingInfo_1 = require("../model/IndexingInfo");
const Invoice_1 = require("../model/Invoice");
const Message_1 = require("../model/Message");
const Patient_1 = require("../model/Patient");
const ReplicationInfo_1 = require("../model/ReplicationInfo");
const ReplicatorDocument_1 = require("../model/ReplicatorDocument");
class IccIcureApi {
    constructor(host, headers, fetchImpl) {
        this.host = host;
        this.headers = Object.keys(headers).map((k) => new XHR_1.XHR.Header(k, headers[k]));
        this.fetchImpl = fetchImpl;
    }
    setHeaders(h) {
        this.headers = h;
    }
    handleError(e) {
        throw e;
    }
    /**
     *
     * @summary Get index info
     */
    getIndexingInfo() {
        let _body = null;
        const _url = this.host + `/icure/i` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl)
            .then((doc) => new IndexingInfo_1.IndexingInfo(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     *
     * @summary Get process info
     */
    getProcessInfo() {
        let _body = null;
        const _url = this.host + `/icure/p` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl)
            .then((doc) => JSON.parse(JSON.stringify(doc.body)))
            .catch((err) => this.handleError(err));
    }
    /**
     *
     * @summary Get replication info
     */
    getReplicationInfo() {
        let _body = null;
        const _url = this.host + `/icure/r` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl)
            .then((doc) => new ReplicationInfo_1.ReplicationInfo(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     *
     * @summary Get replication info
     * @param id
     */
    getReplicatorInfo(id) {
        let _body = null;
        const _url = this.host + `/icure/r/${encodeURIComponent(String(id))}` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl)
            .then((doc) => new ReplicatorDocument_1.ReplicatorDocument(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     *
     * @summary Get version
     */
    getVersion() {
        let _body = null;
        const _url = this.host + `/icure/v` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl)
            .then((doc) => JSON.parse(JSON.stringify(doc.body)))
            .catch((err) => this.handleError(err));
    }
    /**
     *
     * @summary Check if a user exists
     */
    isReady() {
        let _body = null;
        const _url = this.host + `/icure/ok` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl)
            .then((doc) => JSON.parse(JSON.stringify(doc.body)))
            .catch((err) => this.handleError(err));
    }
    /**
     *
     * @summary Resolve contacts conflicts
     * @param limit
     */
    resolveContactsConflicts(limit) {
        let _body = null;
        const _url = this.host + `/icure/conflicts/contact` + '?ts=' + new Date().getTime() + (limit ? '&limit=' + encodeURIComponent(String(limit)) : '');
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl)
            .then((doc) => doc.body.map((it) => new Contact_1.Contact(it)))
            .catch((err) => this.handleError(err));
    }
    /**
     *
     * @summary resolve documents conflicts
     * @param ids
     * @param limit
     */
    resolveDocumentsConflicts(ids, limit) {
        let _body = null;
        const _url = this.host +
            `/icure/conflicts/document` +
            '?ts=' +
            new Date().getTime() +
            (ids ? '&ids=' + encodeURIComponent(String(ids)) : '') +
            (limit ? '&limit=' + encodeURIComponent(String(limit)) : '');
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl)
            .then((doc) => doc.body.map((it) => new Document_1.Document(it)))
            .catch((err) => this.handleError(err));
    }
    /**
     *
     * @summary resolve forms conflicts
     * @param limit
     */
    resolveFormsConflicts(limit) {
        let _body = null;
        const _url = this.host + `/icure/conflicts/form` + '?ts=' + new Date().getTime() + (limit ? '&limit=' + encodeURIComponent(String(limit)) : '');
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl)
            .then((doc) => doc.body.map((it) => new Form_1.Form(it)))
            .catch((err) => this.handleError(err));
    }
    /**
     *
     * @summary resolve healthcare elements conflicts
     * @param limit
     */
    resolveHealthElementsConflicts(limit) {
        let _body = null;
        const _url = this.host + `/icure/conflicts/healthelement` + '?ts=' + new Date().getTime() + (limit ? '&limit=' + encodeURIComponent(String(limit)) : '');
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl)
            .then((doc) => doc.body.map((it) => new HealthElement_1.HealthElement(it)))
            .catch((err) => this.handleError(err));
    }
    /**
     *
     * @summary resolve invoices conflicts
     * @param limit
     */
    resolveInvoicesConflicts(limit) {
        let _body = null;
        const _url = this.host + `/icure/conflicts/invoice` + '?ts=' + new Date().getTime() + (limit ? '&limit=' + encodeURIComponent(String(limit)) : '');
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl)
            .then((doc) => doc.body.map((it) => new Invoice_1.Invoice(it)))
            .catch((err) => this.handleError(err));
    }
    /**
     *
     * @summary resolve messages conflicts
     * @param limit
     */
    resolveMessagesConflicts(limit) {
        let _body = null;
        const _url = this.host + `/icure/conflicts/message` + '?ts=' + new Date().getTime() + (limit ? '&limit=' + encodeURIComponent(String(limit)) : '');
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl)
            .then((doc) => doc.body.map((it) => new Message_1.Message(it)))
            .catch((err) => this.handleError(err));
    }
    /**
     *
     * @summary Resolve patients conflicts
     * @param limit
     */
    resolvePatientsConflicts(limit) {
        let _body = null;
        const _url = this.host + `/icure/conflicts/patient` + '?ts=' + new Date().getTime() + (limit ? '&limit=' + encodeURIComponent(String(limit)) : '');
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl)
            .then((doc) => doc.body.map((it) => new Patient_1.Patient(it)))
            .catch((err) => this.handleError(err));
    }
    /**
     *
     * @summary Force update design doc
     * @param entityName
     * @param warmup
     */
    updateDesignDoc(entityName, warmup) {
        let _body = null;
        const _url = this.host +
            `/icure/dd/${encodeURIComponent(String(entityName))}` +
            '?ts=' +
            new Date().getTime() +
            (warmup ? '&warmup=' + encodeURIComponent(String(warmup)) : '');
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl)
            .then((doc) => JSON.parse(JSON.stringify(doc.body)))
            .catch((err) => this.handleError(err));
    }
}
exports.IccIcureApi = IccIcureApi;
//# sourceMappingURL=IccIcureApi.js.map